import { inject } from '@angular/core';
import { AppRequestContextService } from '../../../app-request-context.service';
import { CanActivateFn, Router } from '@angular/router';
import {
  getFirstOpenedSubsidiaryOrDefault,
  getSortedSubsidiariesByGroup,
} from '@pedix-workspace/pedixapp-shared-catalog';

export const catalogGuardFn: CanActivateFn = () => {
  const appRequestContextService = inject(AppRequestContextService);
  const router = inject(Router);

  const parentEstablishment = appRequestContextService.subsidiaryParentCatalog()?.establishment;
  const establishment = appRequestContextService.establishment();
  const hasSubsidiaries = establishment.subsidiaries && establishment.subsidiaries.length > 0;
  const selectionSource = appRequestContextService.subsidiarySelectionSource();

  if (parentEstablishment?.subsidiarySelector) {
    if (!selectionSource) {
      return router.createUrlTree(['/sucursales/grupos']);
    }
  } else if (hasSubsidiaries) {
    return router.createUrlTree(['/sucursales']);
  }
  return true;
};

export const subsidiariesGuardFn: CanActivateFn = () => {
  const appRequestContextService = inject(AppRequestContextService);
  const router = inject(Router);

  const establishment = appRequestContextService.establishment();
  const hasSubsidiaries = establishment.subsidiaries && establishment.subsidiaries.length > 0;

  if (establishment.subsidiarySelector) {
    return router.createUrlTree(['/sucursales/grupos']);
  } else if (!hasSubsidiaries) {
    return router.createUrlTree(['/']);
  }
  return true;
};

export const subsidiariesGroupsGuardFn: CanActivateFn = async () => {
  const appRequestContextService = inject(AppRequestContextService);
  const router = inject(Router);

  const parentCatalog = appRequestContextService.subsidiaryParentCatalog();

  if (!parentCatalog) {
    return router.createUrlTree(['/']);
  }

  const subsidiaries = appRequestContextService.subsidiaries();
  const subsidiariesByGroup = getSortedSubsidiariesByGroup(subsidiaries);

  if (subsidiariesByGroup.length === 1) {
    const bestSubsidiary = getFirstOpenedSubsidiaryOrDefault(subsidiariesByGroup[0].subsidiaries);

    await appRequestContextService.switchSubsidiaryCatalog({
      establishmentId: bestSubsidiary.id,
      isUserSelected: true,
    });

    return router.createUrlTree(['/']);
  }

  return true;
};
